import * as React from 'react';
import { ArticleHeading1 } from '@cian/ui-kit';

import { AdvantageItem } from './components/AdvantageItem';
import * as styles from './styles.css';
import { IAdvantage } from '../../types/newbuilding/advantages';
import { Layout } from '../Layout';
import { VerticalSliderFullscreen } from '../VerticalSlider';

interface IAdvantagesProps {
  advantages: IAdvantage[];
  onItemClick(i: number): void;
}

export function Advantages({ advantages, onItemClick }: IAdvantagesProps) {
  return (
    <div>
      <Layout>
        <div className={styles['header']}>
          <ArticleHeading1 as="h2" fontWeight="bold">
            Особенности комплекса
          </ArticleHeading1>
        </div>
      </Layout>
      <div className={styles['container']}>
        <VerticalSliderFullscreen onItemClick={onItemClick}>
          {advantages.map(({ title, images }) => (
            <AdvantageItem key={title} title={title} imgUrl={images[0]?.url} />
          ))}
        </VerticalSliderFullscreen>
      </div>
    </div>
  );
}
